import { configureStore } from '@reduxjs/toolkit';
import valueDisplayReducer from '../features/portfolios/edit/portfolio-allocation/value-display-flip-button-slice'
import portfoliosReducer from '../features/portfolios/portfolios-slice'
import collapsibleCompositeReducer from '../features/portfolios/edit/portfolio-allocation/collapsible-composite-slice';
import collapsiblePositionReducer from '../features/portfolios/edit/portfolio-allocation/collapsible-position-slice';
import commandBarReducer from '../features/portfolios/edit/command-bar/command-bar-slice';
import editCompositeReducer from '../features/portfolios/edit/command-bar/edit-composite-slice'
import editPositionReducer from '../features/portfolios/edit/command-bar/edit-position-slice'
import portfolioDetailReducer from '../features/portfolios/detail/portfolio-detail-slice'
import authenticationReducer from '../features/authentication/authentication-slice'
import userReducer from '../features/user/user-slice'
import stockDataReducer from '../features/marketData/stockData/stock-data-slice'
import symbolSearchReducer from '../commonComponents/symbolSearchBar/symbol-search-bar-slice'
import navbarReducer from './navbar-slice'

export const store = configureStore({
  reducer: {
    navbar: navbarReducer,
    portfolios: portfoliosReducer,
    valueDisplay: valueDisplayReducer,
    collapsibleComposite: collapsibleCompositeReducer,
    positionCollapsed: collapsiblePositionReducer,
    commandBar: commandBarReducer,
    editComposite: editCompositeReducer,
    editPosition: editPositionReducer,
    portfolioDetail: portfolioDetailReducer,
    authentication: authenticationReducer,
    user: userReducer,
    stockData: stockDataReducer,
    symbolSearch: symbolSearchReducer,
  }
})

export type AppStore = typeof store
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>